export const STRINGS = {
  appName: "VBGo",
  vbconnectOtherAppsLink: "https://vbconnect.vbgov.com/apps",
  googlePlaystoreLink: "https://play.google.com/store/apps/details?id=com.vbgov.vbevents",
  appleAppstoreLink: "https://itunes.apple.com/us/app/vb-events/id923069978?mt=8",
  seamlessLink: "https://vbforms.seamlessdocs.com/f/591aee3f813a504e82d289d7894aac37",
  feedbackEmail: "comitmobileteam@vbgov.com",
  freebeeLabel: "Freebee Ride",
  fabLabel: "Floating Action",
  filterViewTitle: "Filters",
  category: "Category",
  categories: "Categories",
  list: "List",
  filterResults: "Filter",
  reset: "Reset",
  cancel: "Cancel",
  confirm: "Confirm",
  apply: "Apply",
  ok: "OK",
  settings: "Settings",
  map: "Map",
  eventsTitle: "Events",
  attractionsTitle: "Nearby Attractions",
  parkingTitle: "Nearby Parking",
  bathroomTitle: "Nearby Bathrooms",
  eventDescTitle: "About the event",
  attractionsRoute: "AttractionsDetailsView",
  parkingRoute: "ParkingDetailsView",
  bathroomRoute: "BathroomDetailsView",
  disclaimer: "Disclaimer",
  disclaimerText: "Location was not provided for the event. Please look into the details below for more information.",
  parkingDisclaimer: "Disclaimer: Parking data is updated every 15 minutes, availability is subject to change.",
  text2PayDisclaimerPhoneLicense: "• Enter your phone number and license plate correctly on the next page.",
  text2PayDisclaimerNonGuarantee: "• Parking is not guaranteed and is first come, first served.",
  text2PayDisclaimerReserve: "• Paying ahead does not reserve a parking spot.",
  eventDetails: "Event Details",
  parkingOptions: "Local Parking Options",
  spacesAvailable: "spaces available",
  busStops: "Bus Stops",
  routes: "Routes",
  attractionDetails: "Attraction Details",
  attractionsDescTitle: "About the Attraction",
  tipsTitle: "Tips",
  hoursOfOperation: "Hours of Operation",
  bathroomDetails: "Bathroom Details",
  accessible: "Accessible",
  notAccessible: "Not Accessible",
  closed: "Closed",
  close: "Close",
  winterHours: "Winter Hours",
  summerHours: "Summer Hours",
  springHours: "Spring Hours",
  parkingDetails: "Parking Details",
  parkingType: "Parking Type",
  parkingStatus: "Parking Status",
  freeSpaces: "Free Spaces",
  totalSpaces: "Total Spaces",
  text2Pay: "Text2Pay",
  parkWhiz: "ParkWhiz",
  address: "Address",
  payOnline: "Pay Online",
  about: "About",
  version: "Version",
  feedback: "Feedback",
  submitFeedback: "Submit Feedback",
  visitAppStore: "Visit the App Store and submit a review",
  moreInformation: "More Information",
  downloadOtherApps: "Download other City of Virginia Beach apps",
  couldNotOpenLink: "Could not open link",
  locationUnavailable: "Location Unavailable. Please click on details to get more information.",
  taxiAvailable: "Taxi Access",
  noTaxi: "No Taxi Access",
  aboutEvent: "About the Event",
  noDetails: "No additional details provided.",
  noResults: "No results found",
  pageNotFound: "Page Not Found",
  noCategories: "No categories available",
  connectionError: `Connection error.\n Please try again.`,
  loadingCategories: "Loading categories",
  unknownCapacity: "Unknown Capacity",
  moderateSpaces: "Moderate Spaces",
  fewSpacesLeft: "Few Spaces Left",
  almostFull: "Almost Full",
  full: "Full",
  openDuring: "Open:",
  winter: "Winter",
  summer: "Summer",
  spring: "Spring",
  shareCancelled: "Share cancelled",
  milesAway: "miles away",
  locationPermissionTitle: "Location Permission",
  locationPermissionMessage: "VB Go needs your location to provide you with the best experience.",
  locationPermissionDeniedMessage: "Location permission is currently denied. To show your location on the map, please enable location access for VB Go in your device settings.",
  askMeLater: "Ask Me Later",
  allow: "Allow",
  errorFetchingLocation: "Error fetching location",
  clearAll: "Clear All",
  clearSearch: "Clear Search",
  back: "Back",
  all: "All",
  dataUnavailable: "Data Unavailable",
  datePickerLabel: "Show events between",
  and: "and",
  to: "to",
  moreEvents: "More Events",
  filterBy: "Filter By",
  filteringBy: "Filtering By",
  searchEvents: "Search for events",
  search: "Search",
  refresh: "Refresh",
  allDates: "All Dates",
  resetFilterDates: "Reset Filter Dates",
  applyFilterDates: "Apply Filter Dates",
  closeDateFilter: "Close Date Filter",
  listViewTitle: "{formattedDate} • {eventsTitle} • {totalFound} results",
  loading: "Loading",
  no: "No",
  closeImageButton: "Close images",
  leftCarouselButton: "Previous images",
  rightCarouselButton: "Next image",
  parkingImages: "Parking images",
  parkingMeters: "Parking Meters",
  parkingStructures: "Parking Structures",
  picture: "Picture",
  noImageFound: "No image found",
  pay: "$ Pay",
  website: "Website",
  metaListDescription:
    "Explore events, attractions, parking, and find bathrooms in Virginia Beach. Find the best local experiences and essential information.",
};
export const DATE_FORMAT = { month: "short", day: "numeric" };
